import { render } from "./successPage.vue?vue&type=template&id=b1b7b07e&scoped=true"
import script from "./successPage.vue?vue&type=script&lang=js"
export * from "./successPage.vue?vue&type=script&lang=js"

import "./successPage.vue?vue&type=style&index=0&id=b1b7b07e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b7b07e"]])

export default __exports__